import { ASC, DESC } from 'Angular/constants/core.constants';
import { PaginationControls } from 'Angular/features/components/pagination/pagination.constants';
import { DASHBOARD_FEATURE, DATA_EXPORT_FEATURE, } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.constants';
import { DIRECT_HOLDINGS, INVESTED_HOLDINGS } from 'ModelPortfolioApp/ts/shared/constants';
import { ALL_HOLDINGS, FLATTENED_HOLDINGS, HOLDINGS, INTERSECT_ALL_HOLDINGS, INTERSECT_COMMON_HOLDINGS, INTERSECT_UNIQUE_HOLDINGS, } from 'SecuritiesApp/ts/constants/holdings-table.constants';
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
import { SecuritiesService } from 'SecuritiesApp/ts/services/securities.service';
import { FeatureNeededComponent } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.component';
import { formatUTCDateString, formatUTCMonthDayYear } from 'Angular/utils/date';
import { downloadUrl } from 'Angular/utils/download';
import * as i0 from "@angular/core";
import * as i1 from "EntitlementsApp/ts/features/feature-needed/feature.service";
import * as i2 from "SecuritiesApp/ts/services/securities.service";
export class HoldingsTableDirective {
    constructor(featuresService, securitiesService) {
        this.featuresService = featuresService;
        this.securitiesService = securitiesService;
        this.holdingsLayer = DIRECT_HOLDINGS;
        this.flatByHoldingsLayer = false;
        this.fetchSubscription$ = null;
        this.loading = false;
        this.securityId = '';
        this.displaySecurityId = null;
        this.featurePaymentUrl = '';
        this.hasRequiredFeature = false;
        this.formattedHoldings = [];
        // Pagination
        this.pageNum = 1;
        this.paginationInfo = { current_page_num: 1, num_pages: 1 };
        this.PAGE_CONTROLS = PaginationControls;
        // Sorting
        this.sortColumn = 'current_weight';
        this.sortDirection = DESC;
        // Save As Watchlist
        this.showSaveAsWatchlistResult = false;
        this.saveAsWatchlistResult = '';
    }
    ngOnDestroy() {
        if (this.fetchSubscription$ !== null)
            this.fetchSubscription$.unsubscribe();
    }
    /**
     * Returns a `Holdings` object from `securitiesService` and updates the pagination info.
     * takes into account intersect option and comparable security ids for common holdings functionality
     */
    getHoldings(intersectOption = INTERSECT_ALL_HOLDINGS, comparableSecurityIds = []) {
        if (this.fetchSubscription$ !== null)
            this.fetchSubscription$.unsubscribe();
        this.loading = true;
        if (this.type === FLATTENED_HOLDINGS) {
            if (intersectOption === INTERSECT_COMMON_HOLDINGS || intersectOption === INTERSECT_UNIQUE_HOLDINGS) {
                const flattenedCommonHoldingsFetchParams = {
                    page: this.pageNum,
                    sortBy: this.sortColumn,
                    sortDirection: this.sortDirection,
                    flattened: true,
                    unique: intersectOption === INTERSECT_UNIQUE_HOLDINGS,
                    securityIds: comparableSecurityIds,
                    holdingsLayer: this.holdingsLayer,
                };
                this.fetchSubscription$ = this.securitiesService
                    .getCommonHoldings(this.securityId, flattenedCommonHoldingsFetchParams)
                    .subscribe({
                    next: (rawHoldings) => {
                        this.formattedHoldings = this.formatHoldings(rawHoldings.holdings_data);
                        this.paginationInfo = rawHoldings.pagination_info;
                    },
                    error: () => {
                        this.loading = false;
                    },
                    complete: () => {
                        this.loading = false;
                    },
                });
            }
            else {
                const flattenedHoldingsFetchParams = {
                    page: this.pageNum,
                    sortBy: this.sortColumn,
                    sortDirection: this.sortDirection,
                    holdingsLayer: this.holdingsLayer,
                };
                this.fetchSubscription$ = this.securitiesService
                    .getFlattenedHoldings(this.securityId, flattenedHoldingsFetchParams)
                    .subscribe({
                    next: (rawHoldings) => {
                        this.formattedHoldings = this.formatHoldings(rawHoldings.holdings_data);
                        this.paginationInfo = rawHoldings.pagination_info;
                    },
                    error: () => {
                        this.loading = false;
                    },
                    complete: () => {
                        this.loading = false;
                    },
                });
            }
        }
        if (this.type === ALL_HOLDINGS || this.type === HOLDINGS) {
            if (intersectOption === INTERSECT_COMMON_HOLDINGS || intersectOption === INTERSECT_UNIQUE_HOLDINGS) {
                const commonHoldingsFetchParams = {
                    page: this.pageNum,
                    holdingDate: '',
                    sortBy: this.sortColumn,
                    sortDirection: this.sortDirection,
                    useFundTop25: this.type === HOLDINGS,
                    flattened: false,
                    unique: intersectOption === INTERSECT_UNIQUE_HOLDINGS,
                    securityIds: comparableSecurityIds,
                    holdingsLayer: this.holdingsLayer,
                    flatByHoldingsLayer: this.flatByHoldingsLayer,
                };
                this.fetchSubscription$ = this.securitiesService
                    .getCommonHoldings(this.securityId, commonHoldingsFetchParams)
                    .subscribe({
                    next: (response) => {
                        this.formattedHoldings = this.formatHoldings(response.holdings_data);
                        this.paginationInfo = response.pagination_info;
                    },
                    error: () => {
                        this.loading = false;
                    },
                    complete: () => {
                        this.loading = false;
                        this.asOfDate = this.currentHoldingDate
                            ? formatUTCMonthDayYear(this.currentHoldingDate)
                            : '';
                    },
                });
            }
            else {
                const holdingsFetchParams = {
                    page: this.pageNum,
                    holdingDate: this.currentHoldingDate ? formatUTCDateString(this.currentHoldingDate) : '',
                    sortBy: this.sortColumn,
                    sortDirection: this.sortDirection,
                    useFundTop25: this.type === HOLDINGS,
                };
                this.fetchSubscription$ = this.securitiesService
                    .getHoldings(this.securityId, holdingsFetchParams)
                    .subscribe({
                    next: (response) => {
                        this.formattedHoldings = this.formatHoldings(response.holdings_data);
                        this.paginationInfo = response.pagination_info;
                    },
                    error: () => {
                        this.loading = false;
                    },
                    complete: () => {
                        this.loading = false;
                        this.asOfDate = this.currentHoldingDate
                            ? formatUTCMonthDayYear(this.currentHoldingDate)
                            : '';
                    },
                });
            }
        }
    }
    /**
     * Triggers a document download for the export holdings' data to a CSV file.
     * @param holdingDate - optional string holding date to export holdings for
     * @param intersectOption - optional string comparable intersect option - all/unique/common
     * @param comparableSecurityIds - optional string[] comparable security ids
     */
    exportHoldingDataUrl(holdingDate = '', intersectOption = INTERSECT_ALL_HOLDINGS, comparableSecurityIds = []) {
        if (!this.featuresService.userHasFeatures([DATA_EXPORT_FEATURE])) {
            this.featureNeededModal.openModal(DATA_EXPORT_FEATURE);
            return;
        }
        const exportParams = {
            holdingDate,
            sortBy: this.sortColumn,
            sortDirection: this.sortDirection,
        };
        let url = '';
        if (intersectOption !== INTERSECT_ALL_HOLDINGS) {
            const exportCommonHoldingsParams = {
                holdingDate,
                sortBy: this.sortColumn,
                sortDirection: this.sortDirection,
                flattened: this.type === FLATTENED_HOLDINGS, // these bottom params are only used for common holdings
                unique: intersectOption === INTERSECT_UNIQUE_HOLDINGS,
                securityIds: comparableSecurityIds,
                holdingsLayer: this.holdingsLayer,
            };
            exportCommonHoldingsParams.useFundTop25 = this.type === HOLDINGS; // eslint-disable-line no-param-reassign
            url = this.securitiesService.getCommonHoldingsExportUrl(this.securityId, exportCommonHoldingsParams);
        }
        else if (this.type === HOLDINGS || this.type === ALL_HOLDINGS) {
            exportParams.useFundTop25 = this.type === HOLDINGS; // eslint-disable-line no-param-reassign
            url = this.securitiesService.getSecurityHoldingsExportUrl(this.securityId, exportParams);
        }
        else if (this.type === FLATTENED_HOLDINGS) {
            const flattenedExportParams = {
                holdingDate,
                sortBy: this.sortColumn,
                sortDirection: this.sortDirection,
                holdingsLayer: this.holdingsLayer,
            };
            url = this.securitiesService.getSecurityFlattenedHoldingsExportUrl(this.securityId, flattenedExportParams);
        }
        if (url)
            downloadUrl(url);
    }
    /**
     * Saves the holdings as a watchlist. Updates `saveAsWatchlistResult` and set `showSaveAsWatchlistResult` to true to
     * show the modal with the result.
     */
    saveAsWatchlist(intersectOption = INTERSECT_ALL_HOLDINGS, comparableSecurityIds = []) {
        if (!this.featuresService.userHasFeatures([DASHBOARD_FEATURE])) {
            this.featureNeededModal.openModal(DASHBOARD_FEATURE);
            return;
        }
        const { securityId } = this;
        const displaySecurityId = this.displaySecurityId !== null ? this.displaySecurityId : securityId;
        const failureMessage = 'An error occurred. Please try again or contact support.';
        const maxItemsMessage = 'Watchlists cannot have more than 3000 items.';
        if (this.type === FLATTENED_HOLDINGS) {
            const watchlistName = this.holdingsLayer === INVESTED_HOLDINGS
                ? `Invested Holdings for ${displaySecurityId}`
                : `Underlying Holdings for ${displaySecurityId}`;
            this.securitiesService
                .saveFlattenedHoldingsAsWatchlist(securityId, watchlistName, intersectOption, comparableSecurityIds, this.holdingsLayer)
                .subscribe({
                next: (response) => {
                    this.saveAsWatchlistResult = `Successfully created a holdings overlap watchlist for ${displaySecurityId} (${response.totalItems} items)`;
                    this.showSaveAsWatchlistResult = true;
                },
                error: (e) => {
                    this.saveAsWatchlistResult = e.status === 400 ? maxItemsMessage : failureMessage;
                    this.showSaveAsWatchlistResult = true;
                },
            });
        }
        if (this.type === HOLDINGS || this.type === ALL_HOLDINGS) {
            const asOfString = this.currentHoldingDate
                ? ` (as of ${formatUTCDateString(this.currentHoldingDate)})`
                : '';
            const watchlistName = `Holdings for ${displaySecurityId}${asOfString}`;
            const useFundTop25 = this.type === HOLDINGS;
            const holdingDate = this.currentHoldingDate ? formatUTCDateString(this.currentHoldingDate) : '';
            this.securitiesService
                .saveHoldingsAsWatchlist(securityId, watchlistName, useFundTop25, holdingDate, intersectOption, comparableSecurityIds)
                .subscribe({
                next: (response) => {
                    this.saveAsWatchlistResult = `Successfully created a holdings watchlist for ${displaySecurityId} (${response.totalItems} items)`;
                    this.showSaveAsWatchlistResult = true;
                },
                error: (e) => {
                    this.saveAsWatchlistResult = e.status === 400 ? maxItemsMessage : failureMessage;
                    this.showSaveAsWatchlistResult = true;
                },
            });
        }
    }
    /**
     * Closes the modal showing the result of the `SAVE AS WATCHLIST` button and resets the flag and result message.
     */
    closeModal() {
        this.showSaveAsWatchlistResult = false;
    }
    /**
     * Set a new current holding date and fetch holding data for that data
     * @param newHoldingDate - New date to fetch data for
     */
    handleDateChange(newHoldingDate) {
        this.currentHoldingDate = newHoldingDate;
        this.pageNum = 1;
        this.getHoldings();
    }
    /**
     * Set the new page number and fetch the new list.
     * @param newPageNum - new page number
     * @param intersectOption - optional string comparable intersect option - all/unique/common
     * @param comparableSecurityIds - optional string[] comparable security ids
     */
    pageChanged(newPageNum, intersectOption = INTERSECT_ALL_HOLDINGS, comparableSecurityIds = []) {
        this.pageNum = newPageNum;
        this.getHoldings(intersectOption, comparableSecurityIds);
    }
    /**
     * Handler for the pagination arrows.
     * @param paginationEvent - paginatino change event
     * @param intersectOption - optional string comparable intersect option - all/unique/common
     * @param comparableSecurityIds - optional string[] comparable security ids
     */
    pageChangeHandler(paginationEvent, intersectOption = INTERSECT_ALL_HOLDINGS, comparableSecurityIds = []) {
        if (paginationEvent === this.PAGE_CONTROLS.PREV && this.pageNum === 1)
            return;
        if (paginationEvent === this.PAGE_CONTROLS.NEXT && this.pageNum >= this.paginationInfo.num_pages)
            return;
        let newPageNum;
        switch (paginationEvent) {
            case this.PAGE_CONTROLS.PREV:
                newPageNum = Math.max(this.pageNum - 1, 1);
                break;
            case this.PAGE_CONTROLS.NEXT:
                newPageNum = Math.min(this.pageNum + 1, this.paginationInfo.num_pages);
                break;
            default:
                newPageNum = 1;
        }
        this.pageChanged(newPageNum, intersectOption, comparableSecurityIds);
    }
    /**
     * Sets sort column and sort direction when a column header is clicked
     * @param columnName - name of the column being sorted on
     * @param intersectOption - optional string comparable intersect option - all/unique/common
     * @param comparableSecurityIds - optional string[] comparable security ids
     */
    setTableSortProperties(columnName, intersectOption = INTERSECT_ALL_HOLDINGS, comparableSecurityIds = []) {
        if (columnName === this.sortColumn) {
            this.sortDirection = this.sortDirection === ASC ? DESC : ASC;
        }
        else {
            this.sortColumn = columnName;
            this.sortDirection = ASC;
            this.pageNum = 1;
        }
        this.getHoldings(intersectOption, comparableSecurityIds);
    }
    /**
     * Determines the sort class for each column header
     * @param columnName: column name to get sort class for.
     */
    getSortNgClass(columnName) {
        if (columnName === this.sortColumn) {
            if (this.sortDirection === DESC)
                return 'th-sort-desc';
            if (this.sortDirection === ASC)
                return 'th-sort-asc';
        }
        return '';
    }
}
HoldingsTableDirective.ɵfac = function HoldingsTableDirective_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || HoldingsTableDirective)(i0.ɵɵdirectiveInject(i1.FeatureService), i0.ɵɵdirectiveInject(i2.SecuritiesService)); };
HoldingsTableDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: HoldingsTableDirective, viewQuery: function HoldingsTableDirective_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(FeatureNeededComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.featureNeededModal = _t.first);
    } }, inputs: { type: "type", holdingsLayer: "holdingsLayer", flatByHoldingsLayer: "flatByHoldingsLayer" } });
